
const statusData = [
  { name: "En cours de création", id: "creation", color: "#849191" },
  { name: "En attente", id: "pending", color: "#E3A322" },
  { name: "En cours de souscription", id: "subscribe", color: "#849191" },
  { name: "En cours", id: "inprogress", color: "#008083" },
  { name: "Fini", id: "finished", color: "#91C73C" },
];

const energyData = [
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const membershipStatusData = [
  { name: "Non adhérent", id: "notmember", color: "#008083" },
  { name: "Demande envoyée", id: "requestsent", color: "#3E8FC6" },
  { name: "En cours de traitement", id: "requestpending", color: "#3E8FC6" },
  { name: "Demande refusée", id: "requestrefused", color: "#C53F3F" },
  { name: "Adhérent", id: "member", color: "#91C73C" },
  { name: "En cours de sortie", id: "endinprogress", color: "#C53F3F" },
  { name: "Ancien adhérent", id: "oldmember", color: "#008083" },
];

const membershipStatusDataNoAdmin = [
  { name: "En cours de sortie", id: "endinprogress", color: "#C53F3F" },
];

const ceecaseStatusDataSelect = [
  { name: "En cours de création", id: "creation", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
];
const ceecaseStatusData = [
  { name: "En cours de création", id: "creation", color: "#3E8FC6" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Non valide", id: "refused", color: "#C53F3F" },
];

const ceecasefileStatusDataSelect = [
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Rejeté", id: "refused", color: "#C53F3F" },
  { name: "Non nécessaire", id: "unwanted", color: "#008083" },
];
const ceecasefileStatusDataNoFileSelect = [
  { name: "A compléter", id: "nofile", color: "#C53F3F" },
  { name: "Non nécessaire", id: "unwanted", color: "#008083" },
];
const ceecasefileStatusData = [
  { name: "A compléter", id: "nofile", color: "#C53F3F" },
  { name: "A valider", id: "pending", color: "#3E8FC6" },
  { name: "Validé", id: "accepted", color: "#91C73C" },
  { name: "Rejeté", id: "refused", color: "#C53F3F" },
  { name: "Non nécessaire", id: "unwanted", color: "#008083" },
];

const ceenotificationsRecipienttypeData = [
  { name: "Responsables de dossiers", id: "ceecaseresponsibles" },
]

export { statusData, energyData, membershipStatusData,membershipStatusDataNoAdmin, ceecaseStatusDataSelect,
  ceecaseStatusData,ceecasefileStatusDataSelect,ceecasefileStatusData,ceecasefileStatusDataNoFileSelect,
  ceenotificationsRecipienttypeData
};
